import React, { memo as Memo, useState, useEffect, useMemo, useRef } from 'react'
import { useRouter } from 'next/router'

//* HOC's
import { withDataContext, withUIContext } from 'context'

//* Helpers
import { config } from 'helpers'

//* Components
import { Text, Icon, SingleEvent, Image, CustomLink, Container, Button, Page } from 'components/common'

//* Style
import EventsStyle from 'styles/pages/EventsStyle'

const Events = Memo(({ pageParams, selectedLang, winHeight, ...props }) => {
    const router = useRouter()
    const ref = useRef()
    const [activeEvent, setActiveEvent] = useState('')

    const data = useMemo(
        () => props[pageParams?.singleType]?.[router.query.slug]?.[selectedLang],
        [props?.[pageParams?.singleType], router, selectedLang]
    )

    useEffect(() => {
        if (ref?.current?.getBoundingClientRect().y < winHeight * 0.7) {
            setTimeout(() => {
                setActiveEvent('active')
            }, 300)
        }

        window.addEventListener('scroll', scroll)

        return () => {
            window.removeEventListener('scroll', scroll)
        }
    }, [data])

    const storeEvents = useMemo(() => {
        return data?.relatedEvents.map((i, k) => {
            return (
                <SingleEvent
                    key={k}
                    url={i.slug}
                    title={i.title}
                    date={i.date}
                    category={i.category.name}
                    duration={i.duration}
                    entrance={i.entrance}
                    image={i.featured_image}
                />
            )
        })
    }, [data])

    const scroll = () => {
        if (ref?.current?.getBoundingClientRect().y < winHeight * 0.7) {
            setActiveEvent('active')
        } else {
            setActiveEvent('')
        }
    }

    return data ? (
        <Page meta={data.event.meta}>
            <EventsStyle ref={ref} className={activeEvent}>
                <Container className='FlexBoxColumn'>
                    <CustomLink className='back-btn' url='/'>
                        <Icon className='icon-arrowRight' />
                        <Text tag={'p'} className={'pM NotoSansRegular uppercase'} text={'back'} />
                    </CustomLink>
                    <div className='main-event FlexBox spaceBetween'>
                        <div className='left FlexBoxColumn'>
                            <Text tag={'h4'} className={'date h4 GHEAMariamBold uppercase'} text={data.event.date} />
                            <div className='category FlexBox alignMiddle'>
                                <Icon className='icon-star' />
                                <Text tag={'p'} className={'pM NotoSansRegular uppercase'} text={data.event.category.name} />
                            </div>
                            <Text tag={'p'} className={'title pM NotoSansRegular'} text={data.event.title} />
                            <Text tag={'p'} className={'desc pM NotoSansRegular'} text={data.event.description} />
                            <div className='options FlexBox spaceBetween'>
                                <div className='single-option FlexBoxColumn'>
                                    <Text tag={'p'} className={'uppercase option-title pXS GHEAMariamBold'} text={'duration'} />
                                    <div className='FlexBox'>
                                        <Text tag={'p'} className={'pM NotoSansRegular'} text={data.event.duration} />
                                        &nbsp;
                                        <Text tag={'p'} className={'pM NotoSansRegular'} text={'hour'} />
                                    </div>
                                </div>
                                <div className='single-option FlexBoxColumn'>
                                    <Text tag={'p'} className={'uppercase option-title pXS GHEAMariamBold'} text={'entrance'} />
                                    <Text tag={'p'} className={'pM NotoSansRegular'} text={data.event.entrance} />
                                </div>
                                <div className='single-option FlexBoxColumn'>
                                    <Text tag={'p'} className={'uppercase option-title pXS GHEAMariamBold'} text={'partners'} />
                                    <div className='partners FlexBoxColumn alignEnd'>
                                        {data.event.partners.map((i, k) => {
                                            return <Text tag={'p'} className={'single-partner pM NotoSansRegular'} key={k} text={i} />
                                        })}
                                    </div>
                                </div>
                            </div>
                            <Button text={'visitToFbPage'} link={data.event.url} btnAnimation={true} />
                        </div>
                        <Image src={data.event.featured_image} />
                    </div>
                    <Text tag={'h3'} className={'related-title h3 GHEAMariamBold uppercase'} text={'events'} />
                </Container>
                <div className='events FlexBoxColumn'>{storeEvents}</div>
            </EventsStyle>
        </Page>
    ) : null
})

export default withUIContext(withDataContext(Events, [config.routes.singleEvents.singleType]), ['winHeight'])
